import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.6.4_0e13fd5257b8dba9d4e17f718301a864/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto",
  sensitive: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}